// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qa__success {
  margin-top: 2rem;
  font-size: 1.1rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.qa__reset-button {
  margin-top: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/QASection/QASection.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAAR;AAGI;EACI,gBAAA;AADR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
